document.addEventListener("DOMContentLoaded", function () {
  const bar = document.getElementById("shukhamStickyBar");
  if (!bar) return;

  // Add to Cart — clicks the real hidden button
  //bar.querySelector("[data-add-cart]").addEventListener("click", function () {
    //const realBtn = document.querySelector('.product-form__submit');
    //if (realBtn) realBtn.click();
  //});
  // Add to Cart — enables variant input then submits form
  bar.querySelector("[data-add-cart]").addEventListener("click", function () {
    const variantInput = document.querySelector('.product-variant-id');
    if (variantInput) variantInput.disabled = false;
    const realBtn = document.querySelector('.product-form__submit');
    if (realBtn) realBtn.click();
  });

  // Buy Now — clicks Shopify's dynamic checkout button
  //bar.querySelector("[data-buy-now]").addEventListener("click", function () {
   // const buyBtn = document.querySelector('.shopify-payment-button__button');
    //if (buyBtn) buyBtn.click();
  //});
  // Buy Now — direct Shopify checkout
  bar.querySelector("[data-buy-now]").addEventListener("click", function () {
    const variantInput = document.querySelector('.product-variant-id');
    const variantId = variantInput ? variantInput.value : null;
    if (variantId) {
      window.location.href = '/cart/' + variantId + ':1?checkout';
    } else {
      const productInfo = document.querySelector('product-info');
      if (productInfo) {
        window.location.href = window.location.pathname + '?checkout';
      }
    }
  });

  // Sold out state sync
  const formBtn = document.querySelector('.product-form__submit');
  if (formBtn) {
    const atcBtn = bar.querySelector("[data-add-cart]");
    new MutationObserver(function () {
      const soldOut = formBtn.disabled || formBtn.classList.contains('disabled');
      atcBtn.textContent = soldOut ? 'Sold Out' : 'Add to Cart';
      atcBtn.style.opacity = soldOut ? '0.5' : '1';
      atcBtn.style.cursor = soldOut ? 'not-allowed' : 'pointer';
    }).observe(formBtn, { attributes: true });
  }
});